import React from "react";

export default function Header() {
  return (
    <div className="header">
      <div className="header-left">
        <img src="/images/logo1.jpeg" alt="logo" className="logo-img" />
        <div className="logo-content">
          <span>
            શ્રી વૈભવલક્ષ્મી મહિલા કો-ઓ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી
            લિ.
          </span>

          <p className="reg-number1">રજી. નં. સા. ૩૨૨૮/૧૯૯૯ તા. ૫/૧0/૯૯</p>
        </div>
      </div>
      <div className="header-right">
        <div className="profile">
          <img src="/images/12.png" alt="admin" />
          <span>Admin</span>
        </div>
      </div>
    </div>
  );
}
